import { createResilientFetch, type ResilienceConfig } from "@decocms/apps-vtex/utils/resilience";

// A camada "resilience" do @decocms/apps-vtex (ligada por padrão desde a
// migração de 31/08/2026) aborta qualquer chamada à VTEX sem primeiro byte em
// 8s e abre um circuit breaker por host. No checkout isso é perigoso: o POST
// que dispara a autorização do cartão espera a resposta da adquirente
// (Cielo/Rede2: 7–12s medidos). O worker abortava, o navegador recebia 502
// enquanto a VTEX aprovava a venda, e o cliente pagava de novo — ~27 pedidos
// cobrados em dobro entre 01/09 e 28/10/2026 (zero de maio a agosto).
// Checkout e pagamento passam direto, sem timeout próprio nem breaker; o resto
// (catálogo, busca, sessão) segue protegido.
const CHECKOUT_PATH_PREFIXES = ["/checkout", "/api/checkout", "/api/payments"];

function requestPath(input: RequestInfo | URL): string {
  try {
    if (typeof input === "string") return new URL(input).pathname;
    if (input instanceof URL) return input.pathname;
    return new URL(input.url).pathname;
  } catch {
    return "";
  }
}

export function isCheckoutRequest(input: RequestInfo | URL): boolean {
  const path = requestPath(input);
  return CHECKOUT_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/** Fetch da VTEX com a camada resilience em tudo, menos checkout/pagamento. */
export function createCheckoutAwareFetch(
  underlying: typeof fetch = globalThis.fetch,
  resilience: Partial<ResilienceConfig> = {},
): typeof fetch {
  const resilient = createResilientFetch(underlying, resilience);
  return (input, init) => (isCheckoutRequest(input) ? underlying(input, init) : resilient(input, init));
}
